import { DealerID } from "./Dealer";

export type TyreDiscountID = number;

export type TyreBrandDiscountID = number;

export enum TYRE_DISCOUNT_CATEGORY {
  Cars = 1
}

export interface TyreDiscountCategory {
  id: TYRE_DISCOUNT_CATEGORY;
  name: string; // Name of the tyre discount category
}

export interface TyreDiscount {
  created_on: string;
  updated_on: string;
  id: TyreDiscountID;
  name: string; // Name of the tyre discount
  active: boolean; // Is it active
  discount: number | null; // Discount amount
  net_margin_euro: number | null; // Increase the price for the customer by this amount of euro after the cost of the tyre
  net_margin_percent: number | null; // Increase the price for the customer by this amount of percent after the cost of the tyre
  is_brand_discount_only: boolean; // This discount can be used only with an applied Brand
  dealer_id: DealerID; // Claire identifier for the dealer
  tyre_brand_discounts?: TyreBrandDiscount[]; // Brand discounts associated with the tyre discount
}

export interface TyreBrandDiscount {
  created_on: string;
  updated_on: string;
  id: TyreBrandDiscountID;
  active: boolean; // Is this brand discount active
  discount: number | null; // Discount amount
  net_margin_euro: number | null; // Increase the price for the customer by this amount of euro after the cost of the tyre
  net_margin_percent: number | null; // Increase the price for the customer by this amount of percent after the cost of the tyre
  brand: string; // Identifier of the brand of the tyre
  category: TYRE_DISCOUNT_CATEGORY; // Category of the discount
  tyre_discount_id: TyreDiscountID; // Claire identifier for the tyre discount
}
